import { c as _c } from "react/compiler-runtime";
import type { PlaybookDeploymentResponse, PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Badge } from '@onefootprint/ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { getAuthorName } from '../utils';
type DeploymentEntryProps = {
  deployment: PlaybookDeploymentResponse;
  playbookVersions: PlaybookVersionNoGraph[];
  activeDeploymentId?: string;
};
const DeploymentEntry = t0 => {
  const $ = _c(26);
  const {
    deployment,
    playbookVersions,
    activeDeploymentId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deployment.entry"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const isActive = deployment.id === activeDeploymentId;
  let t2;
  if ($[1] !== deployment.author) {
    t2 = getAuthorName(deployment.author);
    $[1] = deployment.author;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const authorName = t2;
  let t3;
  if ($[3] !== deployment.routingPolicy.versions || $[4] !== playbookVersions) {
    let t4;
    if ($[6] !== playbookVersions) {
      t4 = (v, i) => {
        const pbVersion = playbookVersions.find(pv => pv.id === v.versionId);
        return <span key={v.versionId} className="flex items-center gap-2">{i > 0 && <span className="text-tertiary">·</span>}<span className="text-label-2 text-primary">v{pbVersion?.version ?? "?"}<span className="text-body-2 text-tertiary ml-1">{v.weight}%</span></span></span>;
      };
      $[6] = playbookVersions;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = deployment.routingPolicy.versions.map(t4);
    $[3] = deployment.routingPolicy.versions;
    $[4] = playbookVersions;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="flex items-center gap-2 flex-wrap">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isActive || $[11] !== t) {
    t5 = isActive && <Badge variant="info">{t(_temp)}</Badge>;
    $[10] = isActive;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex items-center justify-between gap-2">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== deployment.createdAt) {
    t7 = format(deployment.createdAt, "yyyy-MM-dd, hh:mm a");
    $[16] = deployment.createdAt;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== authorName) {
    t8 = authorName && <span> · {authorName}</span>;
    $[18] = authorName;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div className="text-caption-2 text-tertiary wrap-anywhere md:wrap-normal">{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t6 || $[24] !== t9) {
    t10 = <div className="flex flex-col gap-1.5 p-3 rounded border border-tertiary">{t6}{t9}</div>;
    $[23] = t6;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default DeploymentEntry;
function _temp($) {
  return $.active;
}